module.exports = __webpack_public_path__ + "img/apple.6aa03320.svg";